





















import { Section } from './mixins';

import { Component, Vue, Prop, Mixins, Emit, Watch } from 'vue-property-decorator';

@Component({
  components: {
    FormImageUpload: () => import('@/components/forms/ImageUpload.vue'),
  },
})
export default class SectionPlacement extends Mixins(Section) {
  @Prop() readonly value!: SectionPlacement;

  productMediaUpdated(media: Array<{ default: number; highlight: number; name: string; path: string }>) {
    // @ts-ignore
    this.localValue.media = media.map((file: { default: number; highlight: number; name: string; path: string }, i: number) => {
      return {
        order: i + 1,
        path: file.path,
        name: file.name,
      };
    });
  }

  get productMedia() {
    if (!this.localValue.media) {
      return [];
    }
    // @ts-ignore
    return this.localValue.media.map((media: ProductImage) => {
      return {
        path: media.path,
        name: media.name,
        default: media.order === 1 ? 1 : 0,
        highlight: media.order === 1 ? 1 : 0,
      };
    });
  }
}
